import { Injectable } from '@angular/core';
import { CloudData } from './metadata/CloudData';

export enum CloudSortingParam {
  name,
  size,
  modifiedTime,
}

export enum CloudSortingOrder {
  ascending,
  descending,
}

export interface CloudSortingData {
  param: CloudSortingParam;
  order: CloudSortingOrder;
}

@Injectable({
  providedIn: 'root'
})

export class CloudSorterService {

  constructor() { }

  sort(list: CloudData[], sortingData: CloudSortingData): CloudData[] {
    switch (sortingData.order) {
      case CloudSortingOrder.ascending:
        switch (sortingData.param) {
          case CloudSortingParam.name: return this.sortNameAscending(list);
          case CloudSortingParam.size: return this.sortSizeAscending(list);
          case CloudSortingParam.modifiedTime: return this.sortModifiedTimeAscending(list);
        }
      case CloudSortingOrder.descending:
        switch (sortingData.param) {
          case CloudSortingParam.name: return this.sortNameDescending(list);
          case CloudSortingParam.size: return this.sortSizeDescending(list);
          case CloudSortingParam.modifiedTime: return this.sortModifiedTimeDescending(list);
        }
    }
  }

  private sortNameAscending(list: CloudData[]): CloudData[] {
    return list.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
  }

  private sortNameDescending(list: CloudData[]): CloudData[] {
    return list.sort((a, b) => b.name.trim().localeCompare(a.name.trim()));
  }

  private sortSizeAscending(list: CloudData[]): CloudData[] {
    return list.sort((a, b) => {
      const aNumber: number = +a.size;
      const bNumber: number = +b.size;
      return aNumber - bNumber;
    });
  }

  private sortSizeDescending(list: CloudData[]): CloudData[] {
    return list.sort((a, b) => {
      const aNumber: number = +a.size;
      const bNumber: number = +b.size;
      return bNumber - aNumber;
    });
  }

  private sortModifiedTimeAscending(list: CloudData[]): CloudData[] {
    return list.sort((a, b) => a.modifiedTime.localeCompare(b.modifiedTime));
  }

  private sortModifiedTimeDescending(list: CloudData[]): CloudData[] {
    return list.sort((a, b) => b.modifiedTime.localeCompare(a.modifiedTime));
  }
}
